module.exports = __webpack_public_path__ + "img/smile.ab138910.png";